import company from './util/company.json';
import apiEnv from './util/apiEnv.json';

import {verifyApiEnv} from './util/verifyApiEnv';
import {getLocalJs} from './util/getLocalJs';

import accurate from '../assets/our-process/accurate.png';
import instantaneous from '../assets/our-process/instantaneous.png';
import video from '../assets/our-process/video.png';
import ourProcess from '../assets/our-process/our-process.jpg';

import calendar from '../assets/other-movers/calendar.png';
import clock from '../assets/other-movers/clock.png';
import inaccurate from '../assets/other-movers/inaccurate.png';
import sad from '../assets/other-movers/sad.png';
import otherMovers from '../assets/other-movers/other-movers.jpg';

import none from '../assets/summary-table/none.png';
import testimonial from '../assets/testimonial/testimonial.jpg';

import step1 from '../assets/steps/step1.png';
import step2 from '../assets/steps/step2.png';
import step3 from '../assets/steps/step3.png';

verifyApiEnv();

const { name, branch: companyBranch, defaultCountry: companyDefaultCountry, domain } = company;

const localJs = getLocalJs(companyBranch);

export const combinedCustomization = {...company,  ...apiEnv, ...localJs};

const getImg = (imgName, defaultImg = null) => {
    try {
        return require(`../../public/img/s3/${combinedCustomization[imgName]}`); // checks if image name from S3 is in local combined customizations file 
    }
    catch (e) {
        return defaultImg; // if not, use the default Img
    }
};

const getComponent = (key) => {
    try {
        if (localJs[key]){
            const componentName = localJs[key]
            return `/branches/${process.env.REACT_APP_API_ENV}/${branch}/${componentName}`
        }
        return null;
    }
    catch (e) {
        return null;
    }
}

// must specify which values you're using from the combined config.
// this way we always have a list of which ones are being used
export const {
    companyName                     = name,
    altCtaPhoneE164, 
    branch                          = companyBranch,
    defaultCountry                  = (companyDefaultCountry || 'US'),
    frontendUrl                     = `${domain}/sign-up`,

    privacyPolicyUrl                = 'https://yembo.ai/legal/consumer/privacy-policy',

    altCtaHref                      = null,
    altCtaLine1                     = "I'd rather talk about it over the phone: ",
    altCtaLine2                     = null,
    showPhoneIconMobile             = true,
    reviewsUrl                      = null,
    headerTitle                     = "The Quickest Moving Quote Possible!",
    headerSubtitle                  = "To get a quote, record a video of your home on your phone. That's it!",
    ctaText                         = null,
    highlightTitle1                 = 'Faster',
    highlightSubtitle1              = "There’s no need to take a day off work or sit through an hour-long video call. Just record a quick video of your home. We do the rest.",
    highlightTitle2                 = 'Easier',
    highlightSubtitle2              = 'Instead of a blanket price, you get an itemized quote based on your exact inventory.',
    highlightTitle3                 = 'Save Money',
    highlightSubtitle3              = 'Is the quote too high? Just remove a few items to bring the quote down.',
    reviewQuote                     = null,
    reviewCaption                   = null,
    ratingCount                     = null,
    reviewStarsNumber               = null,
    reviewStarsTotal                = 5,
    reviewText                      = null,
    testimonialSrc                  = getImg('image_backgroundTestimonial', testimonial),
    closingTitle                    = "Get your no obligation quote now! It's fast and easy!",
    tagline                         = "The most relaxing moving experience.",
    certifications                  = null,
    companyLegalName                = name,
    pageTitle                       = name,
    showOtherMoversSection    = false,
    process1Text                    = 'Immediate and on your own time. Instantaneous!',
    process1Icon                    = getImg('image_instantaneousIcon', instantaneous),
    process2Text                    = 'Takes only minutes for the most accurate quote.',
    process2Icon                    = getImg('image_accurateIcon', accurate),
    process3Text                    = 'Our software uses your video to create a very accurate quote.',
    process3Icon                    = getImg('image_videoIcon', video),
    ourProcessSrc                    = getImg('image_backgroundCompare', ourProcess),
    otherMovers1Text                = 'Schedule an on-site survey, which can take days or weeks.',
    otherMovers1Icon                = getImg('image_calendarIcon', calendar),
    otherMovers2Text                = 'On-site surveys are inconvenient and take hours of your time.',
    otherMovers2Icon                = getImg('image_clockIcon', clock),
    otherMovers3Text                = 'Provide inaccurate quotes on the phone leading to last-minute stress.',
    otherMovers3Icon                = getImg('image_inaccurateIcon', inaccurate),
    otherMoversSrcMobile            = getImg('image_otherMovers', otherMovers),
    sadImgSrc                       = getImg('image_sadIcon', sad),
    step1Text                       = "Walk around your home recording a video of all your belongings.",
    step2Text                       = "Our software scans the video and creates an itemized inventory.",
    step3Text                       = "Get your quote!",
    step1ImageSrc                   = getImg('image_backgroundStep1', step1),
    step2ImageSrc                   = getImg('image_backgroundStep2', step2),
    step3ImageSrc                   = getImg('image_backgroundStep3', step3),
    headerVideoSrc                  = "https://media.yembo.ai/mariner/lander/lander-background.mp4",
    heroImage                       = getImg('image_backgroundHero', null),
    logoHeader                      = getImg('image_logo'),
    logoHeaderRedirect              = getImg('image_logoRedirect'),
    logoFooter                      = getImg('image_logoFooter') || getImg('image_logo'),
    tableNoneIcon                   = getImg('image_noneIcon', none),
    tableCheckIcon                  = getImg('image_checkmark'),
    tableHeaderOurWay               = 'Our New Moving Quote',
    tableHeaderOldWay               = 'Old-Fashioned Moving Quote',
    certificationImg                = getImg('image_copyright'), // getting image by the old name 'image_copyright' but this image actually goes next to the certications section, not copyright
    isPhoneRequired                 = false,
    termsOfUse                      = null,
    testimonialContent              = getComponent('component_testimonialContent'), // keeps testimonial image
    testimonialSection              = getComponent('component_testimonialSection'), // replaces whole section
    processIcons                    = getComponent('component_processIcons'),
    certificationComponent          = getComponent('component_certification'),
    showLogoDropshadow              = false,

    gtmId, 
    s3Bucket,
    apiUrl,
    isDevEnvironment                = (process.env.REACT_APP_API_ENV.startsWith('dev')),
    isProdEnvironment               = (process.env.REACT_APP_API_ENV.startsWith('prod')),

    primaryFill,
    secondaryFill,

    logoFavicon                     = getImg('image_logoFavicon'),
} = combinedCustomization;
